import { Component, Input, OnInit } from '@angular/core';
import { NavigationHandlerService } from '../../../../core/nav/navigation-handler.service';

@Component({
  selector: 'nalco-humbergur-menu-shared-main',
  templateUrl: './humbergur-menu.component.html',
  styleUrls: ['./humbergur-menu.component.scss'],
  standalone: false
})
export class HumbergurMenuComponent implements OnInit {


  @Input() dataSource: any;

  disabled = false;

  constructor(private navService: NavigationHandlerService) {
    navService.navToggle$.subscribe(state => {
      this.disabled = state;
    });

  }

  ngOnInit() {
  }
}
